import { render, staticRenderFns } from "./FormulaColumn.vue?vue&type=template&id=bf0caff6&"
import script from "./FormulaColumn.vue?vue&type=script&lang=ts&"
export * from "./FormulaColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports